import Utils from './Utils.js';

class UrlGenerator {

  constructor(localeService, redirectUrl, verificationServiceUrl, dictionaryServiceUrl, authServiceUrl, openIdServiceUrl) {
    this.localeService = localeService;
    this.redirectUrl = redirectUrl;
    this.verificationServiceUrl = verificationServiceUrl;
    this.dictionaryServiceUrl = dictionaryServiceUrl;
    this.authServiceUrl = authServiceUrl;
    this.openIdServiceUrl = openIdServiceUrl;

  }

  getRegistrationFlowUrl(emailAddress) {

    if (Utils.stringIsInvalidOrEmpty(emailAddress)) {
      throw new Error('emailAddress is required and must be a non empty string');
    }

    return `${this.verificationServiceUrl}/v1/jobseekers/registration-flow?email_address=${encodeURIComponent(emailAddress)}`;

  }

  getRequestVerificationEmailUrl(emailAddress) {

    if (Utils.stringIsInvalidOrEmpty(emailAddress)) {
      throw new Error('emailAddress is required and must be a non empty string');
    }

    let url = `${this.verificationServiceUrl}/v1/jobseekers/request-verification-email?email_address=${encodeURIComponent(emailAddress)}&locale=${encodeURIComponent(this.localeService.getLocale())}`;

    url = appendRedirectUrlIfNecessary(url, this.redirectUrl);

    return url;

  }

  getRequestResetPasswordEmailUrl(emailAddress) {

    if (Utils.stringIsInvalidOrEmpty(emailAddress)) {
      throw new Error('emailAddress is required and must be a non empty string');
    }

    let url = `${this.verificationServiceUrl}/v1/jobseekers/password-token?email_address=${encodeURIComponent(emailAddress)}&locale=${encodeURIComponent(this.localeService.getLocale())}`;

    url = appendRedirectUrlIfNecessary(url, this.redirectUrl);

    return url;

  }

  getTranslationsUrl() {

    return `${this.dictionaryServiceUrl}/v2/translations`

  }

  getPrivacyPolicyUrl() {

    return `${this.dictionaryServiceUrl}/v1/urls/privacy-policy?locale=${encodeURIComponent(this.localeService.getLocale())}`;

  }

  getTermsAndConditionsUrl() {

    return `${this.dictionaryServiceUrl}/v1/urls/terms-and-conditions?locale=${encodeURIComponent(this.localeService.getLocale())}`;

  }

  getRegistrationUrl() {

    return `${this.verificationServiceUrl}/v1/jobseekers/simple`

  }

  getAuthenticationUrl() {

    return `${this.authServiceUrl}/v1/token`;

  }

  getAccessTokenWithOpenIdTokenUrl(token) {

    if (Utils.stringIsInvalidOrEmpty(token)) {
      throw new Error('token is required and must be a non empty string');
    }

    return `${this.openIdServiceUrl}/v1/access-token?token=${encodeURIComponent(token)}&locale=${encodeURIComponent(this.localeService.getLocale())}`;

  }

  getLinkAccountUrl() {

    return `${this.openIdServiceUrl}/v1/login/link-account`;

  }

  getRegisterUrl() {

    return `${this.openIdServiceUrl}/v1/register/complete-account`;

  }

}

let appendRedirectUrlIfNecessary = function (url, redirectUrl) {

  if (!Utils.stringIsInvalidOrEmpty(redirectUrl)) {
    url += `&redirect_url=${encodeURIComponent(redirectUrl)}`;
  }

  return url;

};

export default UrlGenerator;
